import { observer } from 'mobx-react-lite'
import {
  type IRowBase,
  type ITableProps,
  SimpleFilterDropdown,
  type TableStore,
} from 'shared/ui/TableNew'
import styles from './styles.module.scss'

type IHeaderRightContentProps<TRow extends IRowBase> = {
  store: TableStore<TRow>
  rightHeaderContent: ITableProps<TRow>['rightHeaderContent']
}

export const HeaderRightContent = observer(
  <TRow extends IRowBase>({ store, rightHeaderContent }: IHeaderRightContentProps<TRow>) => {
    const { useColumnsCache, columns, visibleColumnsIds, setVisibleColumnsIds } = store.columnsStore

    return (
      <div className={styles.wrap}>
        {rightHeaderContent}
        {useColumnsCache && (
          <SimpleFilterDropdown
            columns={columns}
            visibleColumnsIds={visibleColumnsIds}
            setVisibleColumnsIds={setVisibleColumnsIds}
          />
        )}
      </div>
    )
  }
)
